import { useCore } from '@/composables/core'

export default function (to, from, next) {
  const { store } = useCore()
  store.commit('app/setRoutes', {
    previousRoute: from,
    currentRoute: to,
  })
  next()
}
